import { useCompilation } from "../hooks/useCompilation";

import { CompilationDetailLayout } from "./CompilationDetailLayout";

interface CompilationDetailPreviewProps {
  compilationId: string;
}

/** The heading's shape while a compilation loads; the page and the preview share it. */
export function CompilationHeadingSkeleton() {
  return (
    <div className="flex flex-col items-center lg:mt-30">
      <div className="skeleton-light-bg h-10 w-64 animate-pulse rounded sm:h-12 md:h-14" />
      <div className="mt-4 flex gap-2">
        <div className="skeleton-light-bg h-4 w-24 animate-pulse rounded" />
        <div className="skeleton-light-bg h-4 w-16 animate-pulse rounded" />
      </div>
      <div className="skeleton-light-bg mt-8 h-5 w-80 animate-pulse rounded" />
    </div>
  );
}

/**
 * Lightweight preview of a compilation detail page, shown inside
 * StandardLayout's DragCarousel during a page-level drag gesture.
 *
 * Uses useCompilation (React Query, 24h cache) so data is often
 * already warm. Renders CompilationDetailLayout in preview mode —
 * heading only, no content list or interactive elements.
 */
export function CompilationDetailPreview({
  compilationId,
}: CompilationDetailPreviewProps) {
  const { data: compilation, isLoading } = useCompilation(compilationId);

  if (isLoading || !compilation) {
    return (
      <main className="container mx-auto py-12">
        <CompilationHeadingSkeleton />
      </main>
    );
  }

  return (
    <main className="container mx-auto py-12">
      <CompilationDetailLayout compilation={compilation} preview />
    </main>
  );
}
